export const getNumberFormat = (value: any) => {
  return new Intl.NumberFormat().format(value);
};
